import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Accredible|Badge Search|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareAccredibleBadging,
	htmlAllowed: false,
	portal: 'SP',
};

export type SPToolsAccredibleBadgeSearchLocNames =
	| 'SPToolsAccredibleBadgeSearchNotificationNoCandidatesFound'
	| 'SPToolsAccredibleBadgeSearchNotificationNoAccredibleData'
	| 'SPToolsAccredibleBadgeSearchNotificationAccredibleIdNotFound'
	| 'SPToolsAccredibleBadgeSearchButtonViewCandidate'
	| 'SPToolsAccredibleBadgeSearchTitleDuplicateDataSection';

export const spToolsAccredibleBadgeSearchLocs: LocDefs<SPToolsAccredibleBadgeSearchLocNames> = {
	SPToolsAccredibleBadgeSearchNotificationNoCandidatesFound: {
		defaultValue: 'Candidate has no data at accredible.',
		description: 'No Candidates Found notification message',
		displayPath: `${pathStart}No Candidates Found`,
		displayType: 'Notification',
		legacyName:
			'Share.AccredibleBadging/Accredible.BadgeSearch.NotificationMessage.NoCandidatesFound',
		...sharedProperties,
	},
	SPToolsAccredibleBadgeSearchNotificationNoAccredibleData: {
		defaultValue: 'No Accredible data was found for this candidate.',
		description: 'No Accredible data notification message',
		displayPath: `${pathStart}No Accredible data`,
		displayType: 'Notification',
		legacyName:
			'Share.AccredibleBadging/Accredible.BadgeSearch.NotificationMessage.NoAccredibleData',
		...sharedProperties,
	},
	SPToolsAccredibleBadgeSearchNotificationAccredibleIdNotFound: {
		defaultValue:
			'The Accredible ID for this profile does not exist due to the ID being utilized by a different profile in the system. Please contact support for assistance.',
		description: 'Notification message when Accredible ID does not exist',
		displayPath: `${pathStart}Accredible ID Not Found`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPToolsAccredibleBadgeSearchButtonViewCandidate: {
		defaultValue: 'View Candidate',
		description: 'View Candidate button',
		displayPath: `${pathStart}View Candidate`,
		displayType: 'Button',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Button.ViewCandidate',
		...sharedProperties,
	},
	SPToolsAccredibleBadgeSearchTitleDuplicateDataSection: {
		defaultValue: 'Duplicate Candidate Data',
		description: 'Duplicate Candidate Data section title',
		displayPath: `${pathStart}Duplicate Candidate Data`,
		displayType: 'Title',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Title.DuplicateDataSection',
		...sharedProperties,
	},
};

export type SPToolsAccredibleBadgeSearchLocType = LocMap<SPToolsAccredibleBadgeSearchLocNames>;
